import { render } from "./ProcessSelector.vue?vue&type=template&id=73467dcb&ts=true"
import script from "./ProcessSelector.vue?vue&type=script&lang=ts"
export * from "./ProcessSelector.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__